/**
 * PaymentStatusService
 * Service for PaymentStatus entity operations
 * Route: api/paymentstatuses
 * Controller: PaymentStatusesController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * PaymentStatusService
 * Handles payment status CRUD operations
 * Maps to /api/paymentstatuses endpoint
 */
export class PaymentStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? PaymentStatusService.DEFAULT_SERVICE_PATH,
            basePath: PaymentStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // ==================== CACHE INVALIDATION ====================
    /**
     * Invalidate payment status cache
     * POST /api/paymentstatuses/cache/invalidate
     */
    async invalidateCache() {
        const response = await this.invalidateCacheRaw();
        return response.data ?? false;
    }
    /**
     * Invalidate payment status cache (raw)
     */
    invalidateCacheRaw() {
        const endpoint = this.getEndpoint('cache-invalidate', 'cache/invalidate');
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
}
PaymentStatusService.DEFAULT_SERVICE_PATH = 'orders';
PaymentStatusService.BASE_PATH = 'api/paymentstatuses';
//# sourceMappingURL=PaymentStatusService.js.map